/**
 * Multicolumn section: HLS video init
 * Uses hls.js from theme (loaded in theme.liquid). Videos autoplay muted.
 */
(function () {
  const selector = '.multicolumn-card__video--hls[data-hls-enabled="true"]';

  function initHlsVideo(video) {
    if (!video || video.hlsInstance) return;
    const hlsSrc = video.getAttribute('data-hls-src') || video.getAttribute('data-original-src');
    if (!hlsSrc) return;

    var isHls = hlsSrc.indexOf('.m3u8') !== -1;

    if (!isHls) {
      video.src = hlsSrc;
      video.hlsInstance = { isFallback: true };
      video.play().catch(function () {});
      return;
    }

    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = hlsSrc;
      video.hlsInstance = { isNative: true };
      video.play().catch(function () {});
      return;
    }
    if (typeof window.Hls !== 'undefined' && window.Hls.isSupported()) {
      const hls = new window.Hls({ enableWorker: true, lowLatencyMode: false });
      hls.loadSource(hlsSrc);
      hls.attachMedia(video);
      video.hlsInstance = hls;
      hls.on(window.Hls.Events.MANIFEST_PARSED, function () {
        video.play().catch(function () {});
      });
      hls.on(window.Hls.Events.ERROR, function (e, data) {
        if (data.fatal) {
          const fallback = video.getAttribute('data-original-src');
          if (fallback) {
            video.src = fallback;
            video.play().catch(function () {});
          }
        }
      });
    } else {
      const fallback = video.getAttribute('data-original-src');
      if (fallback) {
        video.src = fallback;
        video.hlsInstance = { isFallback: true };
        video.play().catch(function () {});
      }
    }
  }

  function run() {
    const sections = document.querySelectorAll('.multicolumn');
    if (!sections.length) return;

    function tryInit() {
      if (typeof window.Hls !== 'undefined') {
        sections.forEach(function (section) {
          const videos = section.querySelectorAll(selector);
          videos.forEach(initHlsVideo);
        });
        return;
      }
      setTimeout(tryInit, 80);
    }
    tryInit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
